import React from 'react';

import AggregableMain from '../aggregable/AggregableMain';
import AggregableSummaryDataModel from '../aggregable/AggregableSummaryDataModel';

import ForecastingColumnManager from './ForecastingColumnManager';
import ForecastingDataModel from './ForecastingDataModel';
import ForecastingSummaryView from './ForecastingSummaryView';

export class ForecastingMain extends AggregableMain {
  constructor(props) {
    super(props);

    this.summaryDataModel = new AggregableSummaryDataModel(this.counterparty.preferenceGroupName);

    this.dataModel = new ForecastingDataModel(
      this.locale,
      this.counterparty,
      this.commandDataModel,
      this.summaryDataModel
    );

    this.columnManager = new ForecastingColumnManager(
      this.session,
      this.counterparty
    );
    this.columnManager.settings.loadColumnSettings();
  }

  renderUsageSummaries() {
    return (
      <ForecastingSummaryView
        dataModel={this.summaryDataModel}
        locale={this.locale}
      />
    );
  }
}
